export const css = {
    root: '_3qNbCvwt',
    cards: '_3LX_QgKL',
    studyplan: '_2Z-mQ-p5',
    title: '_307MW3BL',
    ' _key': 'explore-view/chooser'
};
export default css;
